export default [
  {
    id: 1,
    title: 'Simplified Catalogue Creation',
    description: 'Go to catalogue tab to Create new product listings or update quantity and price',
    image: '/images/catalogue-management.png',
  },
  {
    id: 2,
    title: 'One-click Order Management',
    description: 'Accept new orders or view your past orders - from the orders tab',
    image: '/images/order-management.png',
  },
  {
    id: 3,
    title: 'Simplified Payment History',
    description: 'View your upcoming payments and review your past payments',
    image: '/images/payment-history.png',
  },
  {
    id: 4,
    title: 'Create Exclusive bulk Deals',
    description: 'Grow your business with Bulk Deals and get large quantity orders',
    image: '/images/bulk-deals.png',
  },
];
